import { env } from '@/config/env'

/** 浏览器本地会话存储的用户结构（与后端对齐时可扩展） */
export type AuthUser = {
  name: string
  email?: string
}

export const AUTH_USER_STORAGE_KEY = 'minego_auth_user_v1'

/** 生成第三方登录地址（与原 GoBTC 站点逻辑一致，依赖环境变量）。 */
export function getLoginUrl(): string {
  const oauthPortalUrl = env.oauthPortalUrl
  const appId = env.oauthAppId
  if (!oauthPortalUrl || !appId) {
    return `${window.location.origin}/login`
  }

  const redirectUri = `${window.location.origin}/api/oauth/callback`
  const state = btoa(redirectUri)

  const url = new URL(`${oauthPortalUrl.replace(/\/$/, '')}/app-auth`)
  url.searchParams.set('appId', appId)
  url.searchParams.set('redirectUri', redirectUri)
  url.searchParams.set('state', state)
  url.searchParams.set('type', 'signIn')

  return url.toString()
}

export function readStoredUser(): AuthUser | null {
  try {
    const raw = localStorage.getItem(AUTH_USER_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as AuthUser
    if (!parsed?.name) return null
    return parsed
  } catch {
    return null
  }
}

export function writeStoredUser(user: AuthUser) {
  localStorage.setItem(AUTH_USER_STORAGE_KEY, JSON.stringify(user))
}

export function clearStoredUser() {
  localStorage.removeItem(AUTH_USER_STORAGE_KEY)
}
